import { isEvmChainId } from '@1delta/chain-registry'

/** Creates a unique identifier
 * Default format: `${lender}:${chainId}:${underlying.toLowerCase()}`
 * Compound V2 format: `${lender}:${chainId}:${cToken.toLowerCase()}`
 * Init format: `${lender}:${chainId}:${poolId.toLowerCase()}`
 *
 * The ref is lower-cased on EVM chains ONLY, where hex is case-insensitive and
 * a canonical form is what makes look-ups match. It is preserved verbatim
 * everywhere else: base58 is case-SIGNIFICANT, so lower-casing a Solana
 * pubkey does not canonicalize it, it corrupts it.
 *
 * Every one of the 1,100+ EVM chains takes the first branch, so every uid this
 * has ever produced is byte-identical — no served data, KV entry or
 * client-held uid changes.
 *
 * @throws if any argument is missing
 */
export function createMarketUid(
  chainId: string,
  lender: string,
  refAddress: string,
) {
  if (!refAddress || !lender || !chainId) {
    throw new Error(
      `Invalid marketUid parameters: lender=${lender}, chainId=${chainId}, refAddress=${refAddress}`,
    )
  }
  const ref = isEvmChainId(chainId) ? refAddress.toLowerCase() : refAddress
  return `${lender}:${chainId}:${ref}`
}
